import type { z } from 'zod'

import type {
  getLegacyModbusMeterSchema,
  getLegacyModbusTcpSchema,
  getLegacySerialPortSchema,
  getNamedModbusSerialSchema,
  getNamedModbusTcpSchema,
  proposedEditNavigationStateSchema,
} from '@/features/controller/configuration/schemas'

export enum ControllerConfigTypeId {
  RaspiProperties = 'raspi.properties',
  AppJson = 'app.json',
  ResourceJson = 'resource.json',
}

export enum TextEditorLanguage {
  ini = 'ini',
  json = 'json',
  shell = 'shell',
}

export interface ControllerConfigType {
  id: ControllerConfigTypeId
  /** Human-friendly name */
  name: string
  /** The navigation path to navigate to the dedicated editor */
  navigationPath: (controllerId: string) => string
  /** Human-friendly name to be used in tight UI spaces */
  shortName: string
  /** Language to configure the text editor */
  textEditorLanguage: TextEditorLanguage
  /** Distinguisher to show in tight space */
  veryShortName: string
}

export interface ControllerConfigVersionUpdate {
  comment?: string
  previousVersionId: string
  value: string
}

export interface ControllerConfigVersion {
  comment?: string
  createdByUserEnvironment?: string
  createdByUserId?: string
  createdByUsername?: string
  createdAt: string
  id: string
  /** Previous version, missing if this is the very first version. */
  previousVersionId?: string
  sentToControllerAt?: string
  configurationTypeId: ControllerConfigTypeId
  value: string
}

export interface FlexibleConfigDrawerProps<Input, Output> {
  config: Input
  /** Asks the drawer to close. */
  onClose: () => void
  onConfigUpdated: (updatedConfig: Output) => void
  /** Reports that it has finished sliding shut, so the caller can drop it. */
  onFinishedClosing?: () => void
  open: boolean
}

export type ConfigDrawerProps<Config> = FlexibleConfigDrawerProps<Config, Config>

export type LegacySerialPortSchemaType = z.infer<ReturnType<typeof getLegacySerialPortSchema>>
export type LegacyModbusTcpSchemaType = z.infer<ReturnType<typeof getLegacyModbusTcpSchema>>
export type LegacyModbusMeterSchemaType = z.infer<ReturnType<typeof getLegacyModbusMeterSchema>>
export type NamedModbusTcpSchemaType = z.infer<ReturnType<typeof getNamedModbusTcpSchema>>
export type NamedModbusSerialSchemaType = z.infer<ReturnType<typeof getNamedModbusSerialSchema>>
export type ProposedEditNavigationState = z.infer<typeof proposedEditNavigationStateSchema>
